import Vue from 'vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import money from 'v-money';
import VueNumeric from 'vue-numeric'
import VueTabs from 'vue-nav-tabs'
import PSwitch from 'src/components/UIComponents/Switch.vue';
import API from '@/services/API';
import Armazenamento from '@/services/Armazenamento';
import relatorio from '@/services/relatorio'
import modoRelatorio from   'src/components/Dashboard/Views/Simulacoes/Relatorios/modoRelatorio/modoRelatorio'

import('sweetalert2/dist/sweetalert2.css')
Vue.use(ElementUI);
Vue.use(money);
Vue.use(VueNumeric);
Vue.use(VueFormWizard);
Vue.use(VueTabs)

export default {
  name: 'ConfinamentoCompletoCtrl',
  components: {
    PSwitch,
    money,
    'modo-relatorio':  modoRelatorio
  },
  data () {
    return {
      loader: false,
      loading: false,
      descricoes: null,
      dreKeys: [ 'receitaOperacionalBrutaRobCab', 'deducoesCab', 'receitaOperacionalLiquidaRolCab', 'custoProdutoVendidoCpvCab', 'lucroBrutoCab', 'despesaTotalCab', 'ebitdaResultadoOperacionalCab', 'depreciacaoCab', 'amortizacaoCab', 'ebitResultadoOperacionalCab', 'financeiroCab', 'naoOperacionalCab', 'lucroAntesIrLairCab', 'valorIrCab', 'lucroLiquidoCab' ],
      resultadosProdutivosKeys: [ 'pesoEntradaKgBaseOrigem', 'pesoEntradaKgBalancaoDestino', 'pesoEntradaKgBalancinhaDestino', 'pesoEntradaArrobaBaseOrigem', 'pesoSaidaKgBaseOrigem', 'pesoVivoColocadoKgBaseOrigem', 'pesoSaidaArrobaBaseOrigem', 'pesoSaidaKgCarcacaQuenteBaseOrigem', 'quantidadeArrobaProduzidadaCabecaBaseOrigem', 'quantidadeArrobaProduzidadaLoteBaseOrigem', 'quantidadeArrobaAbatidasLoteBaseOrigem', 'idadeAbateMeses', 'cicloProdutivoDias', 'cicloProdutivoMeses', 'pesoVivoMedioDuranteArracoamentoKg', 'mortesCabecas', 'd1Arracoamento', 'dzArracoamento', 'dataEmbarque', 'dataAbate', 'quantidadeContratosBmfProtecaoLote', 'gmdKgdBaseOrigem', 'gmdKgdBaseBalancaoDestino', 'gmdKgdBaseBalancinhaDestino', 'ganhoCarcacaKgdBaseOrigem', 'ganhoCarcacaKgdBaseBalancaoDestino', 'ganhoCarcacaKgdBaseBalancinhaDestino', 'rendimentoGanhoBaseOrigem', 'rendimentoGanhoBaseBalancaoDestino', 'rendimentoGanhoBaseBalancinhaDestino', 'quantidadeArrobaGanhasCabecaMes', 'diasParaGanhar1ArrobaBaseOrigem', 'conversaoAlimentarKgMsKgPV', 'eficienciaBiologicaKgMsArrobaProduziada', 'eficienciaAlimentarKgPvKgMs', 'consumoMedioMateriaSecaDiarioKgCab', 'consumoMedioMateriaOriginalDiarioKgCab' ],
      dre: [],
      resultados: [],
      resultadosEconomicos: [],
      resultadosPrincipais: [],
      resultadosProdutivos: [],
      animais: [],
      entradas: [],
      lista: [],
      nomeImagemParceiro: null,
      urlPdf: null
    }
  },
  methods: {
    pegarDescricao (val) {
      let chave = this.descricoes.items[val];
      if (chave) {
        return chave.titulo;
      } else {
        let result = String(val).replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
      }
    },
    pegarDescricaoPelaLista (lista) {
      return this.pegarDescricao(Object.keys(lista)[0])
    },
    reload () {
      location.reload();
    },
    getInitialValues () {
      const animais = API.listar.animais()
      const descricoes = API.listar.descricoes()
      const estados = API.listar.estados()
      return Promise.all([animais, descricoes, estados])
    },
    getSimulation () {
      let lista = this.$router.history.current.params.lista;
      this.lista = lista;
      const indexRelatorioBase = this.lista.findIndex(el => el.simulacaoBase);
      for (let index = 0; index < lista.length; index++) {
        if (index === indexRelatorioBase) {
          const dadosSaidaBase = lista[index].simulacao_saida.dados.resultados;

          dadosSaidaBase.produtivos.gmdKgdBaseOrigemComparativo = '-';
          dadosSaidaBase.produtivos.gmdKgdBaseBalancaoDestinoComparativo = '-';
          dadosSaidaBase.produtivos.gmdKgdBaseBalancinhaDestinoComparativo = '-';
          dadosSaidaBase.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzidaComparativo = '-'
          dadosSaidaBase.principais.lucroLiquidoCabComparativo = '-';
          dadosSaidaBase.economicos.dre.lucroBrutoCabComparativo = '-'
          dadosSaidaBase.economicos.dre.lucroLiquidoCabComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementadoComparativo = '-'
          dadosSaidaBase.economicos.dre.lucroAntesImpostoRendaComparativo = '-'
          this.lista[index].simulacao_entrada.dados.gmdKgDComparativo = '-'
          this.lista[index].simulacao_entrada.dados.custoNutricaoDiarioMedioCabComparativo = '-'
        } else {
          const relatorioSaidaBase = lista[indexRelatorioBase].simulacao_saida.dados.resultados;
          const relatorioSaidaCurr = lista[index].simulacao_saida.dados.resultados;

          const relatorioEntradaBase = lista[indexRelatorioBase].simulacao_entrada.dados;
          const relatorioEntradaCurr = lista[index].simulacao_entrada.dados;

          // Lucro Liquido Cab Comparativo => Resultados Principais
          relatorioSaidaCurr.principais.lucroLiquidoCabComparativo = this.calcularComparacao(relatorioSaidaBase.principais.lucroLiquidoCab, relatorioSaidaCurr.principais.lucroLiquidoCab, '100')
          // lucroBrutoCabComparativo => DRE do animal suplementado, sem considerar mortalidade
          relatorioSaidaCurr.economicos.dre.lucroBrutoCabComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.dre.lucroBrutoCab, relatorioSaidaCurr.economicos.dre.lucroBrutoCab, '100')
          // lucroLiquidoCabComparativo => do animal suplementado, sem considerar mortalidade
          relatorioSaidaCurr.economicos.dre.lucroLiquidoCabComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.dre.lucroLiquidoCab, relatorioSaidaCurr.economicos.dre.lucroLiquidoCab, '100')
          // Lucro líquido total do lote suplementado => Ótica do investidor arraçoamento próprio)
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalLoteSuplementado, '100')
          // Lucro líquido total do animal suplementado => Ótica do investidor arraçoamento próprio)
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoProprio.lucroLiquidoTotalAnimalSuplementado, '100')
          // Lucro líquido total do lote suplementado => Otica investidor arracoamento terceirizado
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalLoteSuplementado, '100')
          // Lucro líquido total do animal suplementado => Ótica do investidor arracoamento terceirizado
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizado.lucroLiquidoTotalAnimalSuplementado, '100')
          // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO TERCEIRIZADO - MODELO DE ARROBA PRODUZIDA, CONSIDERANDO PERDAS COM MORTALIDADE)
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalLoteSuplementado, '100')
          // relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaProduzida.lucroLiquidoTotalAnimalSuplementado, '100')
          // ÓTICA DO INVESTIDOR (SISTEMA DE ARRAÇOAMENTO TERCEIRIZADO - MODELO DE PARCERIA, CONSIDERANDO PERDAS COM MORTALIDADE)
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalLoteSuplementado, '100')
          relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementadoComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementado, relatorioSaidaCurr.economicos.oticaInvestidor.sistemaArracoamentoTerceirizadoArrobaParceria.lucroLiquidoTotalAnimalSuplementado, '100')
          // GMD
          // Resultados Produtivos
          relatorioEntradaCurr.gmdKgDComparativo = this.calcularComparacao(relatorioEntradaBase.gmdKgD, relatorioEntradaCurr.gmdKgD, '1000')
          // Custo de dieta/suplementação (R$)
          // Custo de nutrição diário médio, R$/cab/dia
          relatorioEntradaCurr.custoNutricaoDiarioMedioCabComparativo = this.calcularComparacao(relatorioEntradaBase.custoNutricaoDiarioMedioCab, relatorioEntradaCurr.custoNutricaoDiarioMedioCab, '100')

          relatorioSaidaCurr.produtivos.gmdKgdBaseOrigemComparativo = this.calcularComparacao(relatorioSaidaBase.produtivos.gmdKgdBaseOrigem, relatorioSaidaCurr.produtivos.gmdKgdBaseOrigem, '1000');
          relatorioSaidaCurr.produtivos.gmdKgdBaseBalancaoDestinoComparativo = this.calcularComparacao(relatorioSaidaBase.produtivos.gmdKgdBaseBalancaoDestino, relatorioSaidaCurr.produtivos.gmdKgdBaseBalancaoDestino, '1000')
          relatorioSaidaCurr.produtivos.gmdKgdBaseBalancinhaDestinoComparativo = this.calcularComparacao(relatorioSaidaBase.produtivos.gmdKgdBaseBalancinhaDestino, relatorioSaidaCurr.produtivos.gmdKgdBaseBalancinhaDestino, '1000')
          // Custo da nutrição por @ produzida, R$/@
          relatorioSaidaCurr.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzidaComparativo = this.calcularComparacao(relatorioSaidaBase.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzida, relatorioSaidaCurr.economicos.analiseEconomica.custoProducao.custoNutricaoPorArrobaProduzida, '100')
          relatorioSaidaCurr.economicos.dre.lucroAntesImpostoRendaComparativo =
          this.calcularComparacao(relatorioSaidaBase.economicos.dre.lucroAntesIrLairCab, relatorioSaidaCurr.economicos.dre.lucroAntesIrLairCab, '100')
        }

        const relatorioSaidaCurr = lista[index].simulacao_saida.dados.resultados;
        const relatorioEntradaCurr = lista[index].simulacao_entrada.dados;

        relatorioSaidaCurr.produtivos.ganhoDePesoKG = relatorioSaidaCurr.produtivos.pesoSaidaKgBaseOrigem - relatorioSaidaCurr.produtivos.pesoEntradaKgBaseOrigem;
        relatorioSaidaCurr.produtivos.ganhoDePesoArroba = (relatorioSaidaCurr.produtivos.pesoSaidaArrobaBaseOrigem - relatorioSaidaCurr.produtivos.pesoEntradaArrobaBaseOrigem).toFixed(2);
        relatorioSaidaCurr.produtivos.quantidadeKGProduzidadaLote = relatorioSaidaCurr.produtivos.ganhoDePesoKG * relatorioEntradaCurr.totalAnimaisLote;

        this.resultados.push(lista[index].simulacao_saida.dados.resultados);
        this.resultadosEconomicos.push(lista[index].simulacao_saida.dados.resultados.economicos);
        this.dre.push(this.sortBy(this.dreKeys, lista[index].simulacao_saida.dados.resultados.economicos.dre))
        this.resultadosPrincipais.push(lista[index].simulacao_saida.dados.resultados.principais);
        this.resultadosProdutivos.push(this.sortBy(this.resultadosProdutivosKeys, lista[index].simulacao_saida.dados.resultados.produtivos))
        lista[index].simulacao_entrada.dados.racaDosAnimais = this.getRaca(lista[index].simulacao_entrada.dados.racaDosAnimais)[0].label;
        lista[index].simulacao_entrada.dados.padraoRacialPredominante = this.getPadraoRacial(lista[index].simulacao_entrada.dados.padraoRacialPredominante)[0].label;
        lista[index].modalidadeDeSistemaDeProducaoEscolhida = lista[index].simulacao_entrada.dados.modalidadeDeSistemaDeProducaoEscolhida
        this.entradas.push(lista[index].simulacao_entrada.dados);
      }
      this.loading = false;
      this.exportReport()
    },
    calcularComparacao(v1, v2, grandeza) {
      const casasAposVirgula = grandeza.length - 1;
      const v1Formated = Number(v1.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)
      const v2Formated = Number(v2.replace(/[^0-9.-]/g, '')).toFixed(casasAposVirgula)

      const result = v2Formated - v1Formated;
      return result.toLocaleString({
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    getRaca (index) {
      let racas = [];
      for (let item = 0; item < this.animais.tipos[0].options.length; item++) {
        racas.push(this.animais.tipos[0].options[item])
      }
      for (let item = 0; item < this.animais.tipos[1].options.length; item++) {
        racas.push(this.animais.tipos[1].options[item])
      }
      racas = racas.filter(function (element) {
        return element.value === index
      })

      if (racas.length === 0) {
        return [{label: '-'}]
      }

      return racas
    },
    getPadraoRacial (index) {
      let padrao = [];
      for (let item = 0; item < this.animais.padrao.length; item++) {
        padrao.push(this.animais.padrao[item])
      }
      padrao = padrao.filter(function (element) {
        return element.value === index
      })

      if (padrao.length === 0) {
        return [{label: '-'}]
      }

      return padrao
    },
    shouldShow (entrada, value) {
      for (let i = 0; i < value.length; i++) {
        if (entrada.modalidadeDeSistemaDeProducaoEscolhida === value[i]) {
          return true
        }
      }
      return false
    },
    exportReport () {
      let doc = relatorio.comparativo.confinamento.avancado.criar(this)
      let pdfBlob = doc.output('blob')
      this.urlPdf = URL.createObjectURL(pdfBlob);
    },
    downloadReport () {
      let doc = relatorio.comparativo.confinamento.avancado.criar(this)
      doc.save('comparativo_confinamento_avancado.pdf')
    },
    sortBy (keys, values) {
      let temp = []
      for (let key of keys) {
        let obj = {}
        obj[key] = values[key]
        temp.push(obj)
      }
      return temp
    }
  },
  created () {
    this.loading = true
    this.getInitialValues().then(([animais, descricoes, estados]) => {
      this.loading = false
      this.descricoes = descricoes;
      this.animais = animais
      const assinatura = Armazenamento.assinatura.pegar()
      const valor = assinatura && assinatura.valor
      this.nomeImagemParceiro = valor && valor.cupom && valor.cupom.nomeImagemParceiro
      this.pegarDescricao(0);
      return this.getSimulation();
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Comparativo/Confinamento/CompletoCtrl.js